'use strict';

var Lock = require('components/common/behaviors/lock');

var CommonViews = {};

CommonViews.TemplateView = function (templatePath, isModal) {
    return Marionette.ItemView.extend({
        template: require(templatePath),

        events: {
            'click a#js-action': 'actionClicked',
            'click a#js-action-2': 'secondaryActionClicked',
            'click .js-checkbox': 'checkboxClicked',
        },

        behaviors: {
            lock: {
                behaviorClass: Lock,
                buttons: ['#js-action', '#js-action-2'],

                getDeviceID: function (view) {
                    return view.getOption('id');
                },
            },
        },

        initialize: function (options) {
            this.options = options || {};

            // uncheck all checkboxes
            this.checkboxState = _.mapObject(this.options.checkboxMap, function (_cb, _key) {
                return false;
            });
        },

        setPermission: function (permissions) {
            // do nothing
            var ro = this.options.readOnlyRight;
            if (ro && permissions.get(ro)) {
                this.options.action_cb = undefined;
                this.options.action_2_cb = undefined;
                this.options.action_label = undefined;
                this.options.action_label_2 = undefined;
            }
        },

        serializeData: function () {
            var self = this;
            var data = {
                checkboxMap: _.mapObject(this.options.checkboxMap, function (cb, key) {
                    cb.checked = self.checkboxState[key];
                    return cb;
                }),
            };

            return $.extend(data, this.options);
        },

        checkboxClicked: function (e) {
            this.checkboxState = _.mapObject(this.options.checkboxMap, function (_cb, key) {
                var checkboxElement = $('#js-' + key);
                if (checkboxElement.length === 0) {
                    return false;
                }
                return checkboxElement.prop('checked');
            });
            this.render();
        },

        actionClicked: function (e) {
            e.preventDefault();
            if (isModal) {
                var App = require('app');
                App.hideModal();
            }

            this.options.action_cb(this.checkboxState);
        },

        secondaryActionClicked: function (e) {
            e.preventDefault();
            if (isModal) {
                var App = require('app');
                App.hideModal();
            }
            this.options.action_2_cb(this.checkboxState);
        },
    });
};

CommonViews.Confirmation = CommonViews.TemplateView('components/common/templates/confirm', true);
CommonViews.Hint = CommonViews.TemplateView('components/common/templates/hint');
CommonViews.Loading = CommonViews.TemplateView('components/common/templates/loading');
CommonViews.Message = CommonViews.TemplateView('components/common/templates/message');
CommonViews.NotFound = CommonViews.TemplateView('components/common/templates/notfound');
CommonViews.Alert = CommonViews.TemplateView('components/common/templates/alert');

module.exports = CommonViews;
